/**
 * Accordion Parser
 * Converts custom accordion markup to styled divs
 */

document.addEventListener('DOMContentLoaded', function () {
  const articleContent = document.querySelector('.article-content');

  console.debug('articleContent');

  if (!articleContent) return;

  // Get the HTML content
  let html = articleContent.innerHTML;

  // First, replace the inner tags (title and content)
  html = html.replace(
    /&lt;accordion-title&gt;([\s\S]*?)&lt;\/accordion-title&gt;/gi,
    '<div class="accordion-title">$1</div>',
  );
  html = html.replace(
    /&lt;accorditon-title&gt;([\s\S]*?)&lt;\/accorditon-title&gt;/gi,
    '<div class="accordion-title">$1</div>',
  );
  html = html.replace(
    /&lt;accordion-content&gt;([\s\S]*?)&lt;\/accordion-content&gt;/gi,
    '<div class="accordion-content-wrapper"><div class="accordion-content">$1</div></div>',
  );
  html = html.replace(
    /&lt;accorditon-content&gt;([\s\S]*?)&lt;\/accorditon-content&gt;/gi,
    '<div class="accordion-content-wrapper"><div class="accordion-content">$1</div></div>',
  );

  // Then replace the accordion wrapper
  html = html.replace(
    /&lt;accordion(?:[\s]+data-style=(?:&quot;|")([^&"']*)(?:&quot;|"))?&gt;([\s\S]*?)&lt;\/accordion&gt;/gi,
    function (match, styleNum, content) {
      const styleAttr = styleNum ? ` data-style="${styleNum}"` : '';
      return `<div class="custom-accordion"${styleAttr}>${content}</div>`;
    },
  );

  // Update the content
  articleContent.innerHTML = html;

  // Add event listeners for accordion toggle
  const accordions = articleContent.querySelectorAll('.custom-accordion');

  accordions.forEach((accordion) => {
    const title = accordion.querySelector('.accordion-title');
    const wrapper = accordion.querySelector('.accordion-content-wrapper');
    const content = accordion.querySelector('.accordion-content');

    if (title && wrapper) {
      title.addEventListener('click', function () {
        // Toggle active class on title
        title.classList.toggle('is-active');

        // Toggle wrapper visibility
        if (wrapper.style.maxHeight) {
          // Close it
          wrapper.style.maxHeight = null;
        } else {
          // Open it
          wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        }
      });
    } else if (title && content) {
      // Fallback
      title.addEventListener('click', function () {
        title.classList.toggle('is-active');
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    }
  });
});
